import { Identifiers, SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'home',
    useLayout: true,
    children: [
        { id: SectionsKey.Hero, order: 1, identifier: Identifiers.Hero },
        { id: SectionsKey.PromotionBanner, order: 2, identifier: Identifiers.PromotionBanner },
        { id: SectionsKey.Brand, order: 3, identifier: Identifiers.HomeBrand },
        { id: SectionsKey.RecentlyView, order: 4 },
        { id: SectionsKey.TopCategory, order: 5, identifier: Identifiers.TopCategories },
        { id: SectionsKey.BestSeller, order: 6, identifier: Identifiers.BestSeller },
        { id: SectionsKey.FeatureProduct, order: 7, identifier: Identifiers.FeatureProduct },
        { id: SectionsKey.NewCollections, order: 8, identifier: Identifiers.NewCollection },
        { id: SectionsKey.Trending, order: 9, identifier: Identifiers.TrendingBanner },
        { id: SectionsKey.Recommended, order: 10, identifier: Identifiers.Recommended },
        { id: SectionsKey.Testimonial, order: 11, dataKey: SectionsKey.Testimonial, identifier: Identifiers.Testimonial }
    ]
};

export default PageStruct;
